import React from 'react';
import AdverseCorporateEventsComponent from "./AdverseCorporateEventsComponent";
import {padCalendar} from "../../../util";

function formatAdverseCorporateEvents(adverseCorporateEvents) {
    for (const adverseCorporateEvent of adverseCorporateEvents) {
        adverseCorporateEvent.date = padCalendar(adverseCorporateEvent.date);
    }
    
    return adverseCorporateEvents.filter(adverseCorporateEvent => adverseCorporateEvent.vFiltersPass === true);
}

const AdverseCorporateEventsContainer = (props) => {

    if (!props.adverseCorporateEvents) {
        return <div>Loading</div>
    }

    const data = formatAdverseCorporateEvents(props.adverseCorporateEvents);

    return (
        <React.Fragment>
            <AdverseCorporateEventsComponent adverseCorporateEvents={data} />
        </React.Fragment>
    );

};


export default AdverseCorporateEventsContainer;


// WEBPACK FOOTER //
// ./src/common/components/AdverseCorporateEvents/AdverseCorporateEventsContainer.js